<template>
  <div class="WelcomeMessage flex justify-center p-5">
    <p class="p-5 border text-gray-700">
      Welcome to your new Landscape!<br />
      Start adding actors to map
      <span class="text-gray-900">{{ currentLandscape.name }}</span> by clicking
      <span class="text-gray-900 whitespace-nowrap">New Actor</span>.
    </p>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'WelcomeMessage',
  computed: {
    ...mapGetters(['currentLandscape'])
  }
}
</script>
